import fdbackIntroJson from '@/mock/stufdbackintro.js'

export const helpFdbackData = (params, cb, error) => {
    cb(fdbackIntroJson)
}




// WEBPACK FOOTER //
// ./src/api/stufdback.js